import { useParams } from "react-router"

import DataPointEditor from "@/features/datapoints/components/DataPointEditor.tsx"
import type { DataPointType } from "@/types/dataPointTypes.ts"

export default function NewDataPoint() {
  const params = useParams()
  const type = params.type

  return <DataPointEditor type={type as DataPointType} />
}
